import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'ras-banner',
	templateUrl: './banner.component.html',
	styleUrls: ['./banner.component.sass']
})
export class BannerComponent implements OnInit {

	@Input() html: string;
	@Input() heading: string;
	@Input() picture: string[];
	@Input('picture-align') align: string;
	@Input() top: string;
	@Input() bottom: string;
	@Input() colour: string;

	constructor() { }

	ngOnInit(): void {
	}

}
